<template>
  <section>
    <el-row style="padding:15px 0;background:#fff">
      <el-col :sm="24" :xs="24">
        <el-row :gutter="10">

          <el-select class="xs24" v-model="pdata.source" placeholder="请选择小游戏来源" @change="getList" clearable >
          	<el-option :label="v" :value="v" v-for="(v,i) in issued_app_source" :key="i"></el-option>
          </el-select>

          <el-input
            @clear="getList"
            @keyup.enter.native="search"
            ref="input"
            class="search xs24"
            v-model="pdata.kw"
            clearable
            placeholder="请输入小程序名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>
        </el-row>
      </el-col>
    </el-row>
    <el-row >
      <el-button size="small" type="primary" @click="addProduct">新增</el-button>
      <el-button size="small" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="small" type="danger" @click="changeStatus(false,0)">禁用</el-button>
      <el-button size="small" type="info" @click="changeStatus(false,-1)">删除</el-button>
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%; margin-top: 30px;"
      stripe
      row-key="id"
      @selection-change="select"
    >

      <el-table-column type="selection" min-width="30px"></el-table-column>
      <el-table-column prop="id" label="ID" width="80px" min-width="40px" align="left"></el-table-column>
      <el-table-column prop="name" label="游戏名称" width="250px" align="left">
        <template slot-scope="scope">
        	<img :src="scope.row.icon" alt  width="32px" height="32px" style="vertical-align: middle;border-radius: 50%;margin: 0 5px;">
          <el-button type="text" @click="editProduct(scope.row)">{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="source" label="来源"  align="center"></el-table-column>
      <el-table-column prop="platform" label="所属平台" min-width="80px" align="left">
      	<template slot-scope="scope">
      		<el-tag
				    v-for="item,index in scope.row.platform"
				    :key="item"
				    :type="''"
				    effect="plain"
				    size="mini"
				    style="margin:0 5px;"
				    >
				    {{ item }}
				  </el-tag>
         
        </template>
      </el-table-column>

      
      
      <el-table-column prop="status" label="产品状态" width="80px" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
      </el-table-column>
      
      
   
   
    </el-table>

    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>

    <el-dialog
      :title="isAdd?'新增产品信息':'编辑产品信息'"
      :visible.sync="editDialog"
      top="5vh"
      width="950px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
        <el-form-item label="小游戏名称" prop="name" >
          <el-input v-model="chooseProduct.name" placeholder="小游戏名称" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="曾用名" prop="rename"  >
          <el-input v-model="chooseProduct.rename" placeholder="曾用名" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="游戏图标" prop="icon" >
          <UploadImg :image="chooseProduct.icon" v-on:update:image="chooseProduct.icon=$event"></UploadImg>
        </el-form-item>
        <!--<el-form-item label="游戏类型">
          <el-radio-group v-model="chooseProduct.type">
            <el-radio :label="v" :value="v" v-for="(v,i) in product_theme" :key="i"></el-radio>
          </el-radio-group>
        </el-form-item>-->
       
        <el-form-item label="游戏来源">
           <el-radio-group v-model="chooseProduct.source">
					    <el-radio :label="v" :value="v"  v-for="(v,i) in issued_app_source" :key="i"></el-radio>
					  </el-radio-group>
        </el-form-item>
        <el-form-item label="分成公司">
	        <el-select v-model="chooseProduct.cp_company_id" filterable  clearable    placeholder="请选择分成公司名称">
			    <el-option
			      v-for="item in companyList"
			      :key="item.id"
			      :label="item.name"
			      :value="item.id">
			    </el-option>
				</el-select>
			 </el-form-item>
			 
         <el-form-item label="平台标识">
         	 <el-checkbox-group v-model="chooseProduct.platform_id" >
				    <el-checkbox :label="i+1" :value="i+1" v-for="(v,i) in  get_issued_app_platform"  :key="i+1" @click.native="platformChange($event,(i+1))">{{v}} </el-checkbox>
				  </el-checkbox-group>
				  
        </el-form-item>
        
        <el-tabs v-model="editableTabsValue" type="card" :closable="false" style="margin-left:120px;">
					  <el-tab-pane
					    v-for="(item, index) in editableTabs"
					    :key="item.name"
					    :label="item.title"
					    :name="item.name"
					  >

					   	  <el-form-item label="platform_id"   v-show="false">
				          <el-input v-model="platform[item.name -1].platform_id" placeholder="" class="input" clearable :value="item.name"></el-input>
				        </el-form-item>
				        <el-form-item label="小游戏名称" >
				          <el-input v-model="platform[item.name -1].name" placeholder="请输入小游戏名称" class="input" clearable></el-input>
				        </el-form-item>
				         <el-form-item label="小游戏曾用名" >
				          <el-input v-model="platform[item.name -1].rename" placeholder="请输入小游戏曾用名" class="input" clearable></el-input>
				        </el-form-item>
	    	      	<el-form-item label="APPID" >
				          <el-input v-model="platform[item.name -1].appid" placeholder="请输入小游戏appid" class="input" clearable></el-input>
				        </el-form-item>
				        <el-form-item label="APPSECRET"  >
				          <el-input
				            v-model="platform[item.name -1].appsecret"
				            placeholder="请输入APPSECRET"
				            class="input"
				            clearable
				          ></el-input>
				        </el-form-item>
				        <div v-if="item.name==1">
					        <el-form-item label="邮箱"  >
					          <el-input v-model="platform[item.name -1].email" placeholder="请输入邮箱" class="input" clearable></el-input>
					        </el-form-item>
					        <el-form-item label="密码"  >
					          <el-input v-model="platform[item.name -1].password" placeholder="请输入密码" class="input" clearable></el-input>
					        </el-form-item>
					        <el-form-item label="主体">
					          <el-radio-group v-model="platform[item.name -1].body">
					            <el-radio :label="v" :value="v" v-for="(v,i) in app_body" :key="i"></el-radio>
					          </el-radio-group>
					        </el-form-item>
				        </div>
				        
				        <div v-if="item.name==3">
					        <el-form-item label="账号"  >
					          <el-input v-model="platform[item.name -1].email" placeholder="请输入邮箱" class="input" clearable></el-input>
					        </el-form-item>
					        <el-form-item label="密码"  >
					          <el-input v-model="platform[item.name -1].password" placeholder="请输入密码" class="input" clearable></el-input>
					        </el-form-item>
				        </div>
				        
				        <el-form-item label="分成方式">
				          <el-radio-group v-model="platform[item.name -1].divide">
								    <el-radio label="原生">原生</el-radio>
								    <el-radio label="利润">利润</el-radio>
								  </el-radio-group>
					      </el-form-item>
					      <el-form-item label="分成占比"  prop="divide_per" >
				          <el-input
				            v-model="platform[item.name -1].divide_per"
				            placeholder="请输入分成占比"
				            class="input"
				            clearable
				          ></el-input>
				          	（给到对方的分成占比,0-1）
					      </el-form-item>
				        
				        <div v-if="item.name==1">
				        	<el-form-item label="小游戏数据采集账号">
					           <el-radio-group v-model="platform[item.name -1].game_miniprogram_account">
										    <el-radio :label="i" :value="i"  v-for="(v,i) in game_miniprogram_account" :key="i">{{v}}</el-radio>
										  </el-radio-group>
					        </el-form-item>
					        <el-form-item label="小程序码" prop="qrcode" >
					          <UploadImg :image="platform[item.name -1].qrcode" v-on:update:image="platform[item.name -1].qrcode=$event"></UploadImg>
					        </el-form-item>
				        </div>
				        
				       
				        
				
					    
					    
					    
	
					    
					    
					  </el-tab-pane>
					</el-tabs>
      
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { getPlist, getPAdd, getPEdit,getPGetEdit, getPStatus,getCPCompanyList } from "../../api/api";
// import { splist, saddp, spstatus, splog, seditp, scopy } from "../api/api";
import UploadImg from "../uploadImg.vue";

export default {
  components: {
    UploadImg
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
        short_name: [
          { required: true, message: "请输入短名称", trigger: "blur" }
        ],
        appid: [
          { required: true, message: "请输入产品appid", trigger: "blur" }
        ],
        icon: [{ required: true, message: "请上传产品图片", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // divide_per: [
        //   { required: true, message: "请输入分成占比", trigger: "blur" }
        // ],
        appsecret: [
          { required: true, message: "请输入appsecret", trigger: "blur" }
        ]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        source: "",
        kw: ""
      },
      plist: [],
      maxPage: 1,
      product_theme: [], //游戏类型
      app_body: [], //游戏主体
      tags: [], //游戏标签
      issued_app_source:[],//游戏来源 
      game_miniprogram_account:[], //游戏采集账号
      get_issued_app_platform:[],
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "120px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        app_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      companyList:[],
      editableTabsValue: '1',
	    editableTabs: [],
      tabIndex: 0,
      platform:[],
     
    };
  },
  watch: {
    "chooseTags.length": {
      handler(n, o) {
        this.chooseProduct.divide = this.chooseTags.join(",");
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
  	platformChange(e,v){
  		if (e.target.tagName === 'INPUT'){
  			
  			return
      }
  		
  		console.log(this.chooseProduct.platform_id,v)
  		if(this.chooseProduct.platform_id.indexOf(v)==-1){
  			//增加
  			this.editableTabs.push({
  				title:this.get_issued_app_platform[(v-1)],
  				name:v.toString(),
  				content:'content'
  			})
  			this.editableTabs.sort(function(a, b){return a.name - b.name})
  			this.editableTabsValue = v.toString();
  			this.platform[v-1].platform_id=v;
  			this.platform[v-1].name='';
  			this.platform[v-1].rename='';
  			this.platform[v-1].appid='';
  			this.platform[v-1].appsecret='';
  			this.platform[v-1].email='';
  			this.platform[v-1].password='';
  			this.platform[v-1].body='';
  			this.platform[v-1].divide='';
  			this.platform[v-1].divide_per='';
  			this.platform[v-1].game_miniprogram_account='';
  			this.platform[v-1].qrcode='';


  		}
  		else{
  			var obj
  			this.editableTabs.forEach((vv,ii)=>{
  				if(vv.name == v){
  					obj = vv;
  				}
  			})
  			this.editableTabs = this.removeAaary(this.editableTabs,obj)
  			this.platform[v-1].platform_id='';
  			this.editableTabsValue = '1';
  			this.editableTabs.sort(function(a, b){return a.name - b.name})
  			//删除
  		}
  		
  		
  		
  		
  	},
  	removeAaary(_arr, _obj) {
		    var length = _arr.length;
		    for (var i = 0; i < length; i++) {
		        if (_arr[i] == _obj) {
		            if (i == 0) {
		                _arr.shift(); //删除并返回数组的第一个元素
		                return _arr;
		            }
		            else if (i == length - 1) {
		                _arr.pop();  //删除并返回数组的最后一个元素
		                return _arr;
		            }
		            else {
		                _arr.splice(i, 1); //删除下标为i的元素
		                return _arr;
		            }
		        }
		    }
		},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      p = p.slice(0, -1);
      getPlist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.plist = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.product_theme = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.app_body = this.$store.config.app_body;
        this.game_miniprogram_account= this.$store.config.game_miniprogram_account; //游戏采集账号
        this.issued_app_source=this.$store.config.issued_app_source; //游戏来源
        this.get_issued_app_platform = this.$store.config.get_issued_app_platform; //发行账号平台标识
        this.platform=JSON.parse(JSON.stringify(this.$store.config.get_issued_app_platform)).map((v,i)=>{
	      	return {name:'',rename:'', platform_id:'',appid:'',appsecret:'',email:'',password:'',body:'',divide:'',divide_per:'',game_miniprogram_account:'',qrcode:''}
	      });
        if( this.game_miniprogram_account.indexOf('无')==-1){
        	this.game_miniprogram_account.unshift('无');
        }
       // this.game_miniprogram_account.unshift('无');
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct(d) {
    	this.platform.forEach((v,i)=>{
    		 for(let key in v){
		         v[key]  = ''
		     }
    	})
    	this.chooseProduct = {
        name: "",
        rename: "",
        icon: "",
        source: "内部游戏",
        cp_company_id:'',
        log: "新增产品",
        platform_id:[],
        platform:[],
      };


      this.editableTabs =[];
      this.editDialog = true;
      this.chooseProduct.app_base_id = JSON.parse(JSON.stringify(d)).id;
      getPGetEdit('app_base_id='+this.chooseProduct.app_base_id,this.$cookie.getCookie("login")).then(res=>{
			
      	if(res.code == 200){
      		//this.chooseProduct = res.data
      		this.chooseProduct.name = res.data.name;
      		this.chooseProduct.rename = res.data.rename;
      		this.chooseProduct.icon = res.data.icon;
      		this.chooseProduct.cp_company_id = res.data.cp_company_id;
      		this.chooseProduct.source =res.data.source;
 
      		if(res.data.platform&&res.data.platform.length>0){
	      			this.chooseProduct.platform_id =JSON.parse(JSON.stringify(res.data.platform)).map((v,i)=>{ return parseInt(v.platform_id)});
	      			this.chooseProduct.platform_id.forEach((v,i)=>{
					  			//增加
					  			this.editableTabs.push({
					  				title:this.get_issued_app_platform[(v-1)],
					  				name:v.toString(),
					  				content:'content'
					  			})
					  			this.editableTabs.sort(function(a, b){return a.name - b.name})
					  			
					  			this.editableTabsValue = this.editableTabs[0].name;
				      });
			      	res.data.platform.forEach((v,i)=>{
			      		this.platform[v.platform_id-1].name=v.name;
			      		this.platform[v.platform_id-1].rename=v.rename;
				      	this.platform[v.platform_id-1].appid=v.appid;
								this.platform[v.platform_id-1].appsecret=v.appsecret;
								this.platform[v.platform_id-1].body=v.body;
								this.platform[v.platform_id-1].divide=v.divide;
								this.platform[v.platform_id-1].divide_per=v.divide_per;
								this.platform[v.platform_id-1].email=v.email;
								this.platform[v.platform_id-1].game_miniprogram_account= parseInt(v.game_miniprogram_account);
								this.platform[v.platform_id-1].index_id=v.index_id;
								this.platform[v.platform_id-1].password=v.password;
								this.platform[v.platform_id-1].platform_id=v.platform_id;
				      })
      		}
		     
		      
		      
	

      	}
    		
    	})
     
     
     
     
	     
      //this.chooseTags = this.chooseProduct.divide.split(",");
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
      this.$prompt("请输入编辑原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "内容不能为空"
      }).then(({ value }) => {
        if (isSingle) {
          this.cP.app_base_id = s.id;
          this.cP.status = s.status == 1 ? "0" : "1";
        } else {
          this.cP.status = s;
        }
        this.cP.log = value;
        getPStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.getList();
            this.$message({ message: "状态修改成功", type: "success" });
          }
        });
      });
    },
    addProduct() {
    	this.editableTabs =[];
      this.chooseProduct = {
        name: "",
        rename: "",
        icon: "",
        source: "内部游戏",
        cp_company_id:'',
        log: "新增产品",
        platform_id:[],
        platform:[],
      };
      this.editDialog = true;
      this.chooseTags = ["原生"];
      this.isAdd = true;
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

			    var arr =[];
			    this.platform.forEach((v,i)=>{
			    	if(v.platform_id != ''){arr.push(v) }
			    })
			    this.chooseProduct.platform = arr;
			    
          console.log( this.chooseProduct)
          debugger
          if (!this.isAdd) {
          	this.chooseProduct.log = "编辑内容";
          	getPEdit(this.chooseProduct, this.$cookie.getCookie("login")).then(res => {
              if (res.code == 200) {
                this.getList();
                this.editDialog = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
          else{
          	getPAdd(this.chooseProduct, this.$cookie.getCookie("login")).then(res => {
              if (res.code == 200) {
                this.getList();
                this.editDialog = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
         
        } else {
          return false;
        }
      });
    },
    select(s) {
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.app_base_id = p.slice(2);
    },
    openDealy(id) {
      splog(id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  mounted() {
  	this.getConfig();
  	
   
    this.headMsg.token = this.$cookie.getCookie("login");
    getCPCompanyList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.list.length>0){
        		this.companyList = res.data.list;
        	}
          
        }
      });
     
     this.getList();
  
    // scopy("我的", this.$cookie.getCookie("login")).then(res => {});
  }
};
</script>
<style scoped>
.dialog {
  width: 800px;
}
</style>

<style>
	.el-table td, .el-table th{
		padding:5px 0;
	}
.gameIcon {
  width: 60px;
  height: 60px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 200px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pagination {
  /* float: right; */
  /* margin-top: 30px; */
  /* min-width: 1200px; */
  padding: 20px;
}
.el-upload-list__item {
  line-height: 0;
}
.el-radio {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// pList.vue?7c35dcb3